import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification is-danger"
}
const _hoisted_2 = { class: "fieldset" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Акция", -1)
const _hoisted_5 = { class: "control" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- Не выбрано --", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сумма начисления", -1)
const _hoisted_10 = { class: "control" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-help" }, "Если сумма не указана, будет начислена стандартная сумма в рамках акции", -1)
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Ссылка на лида или номер", -1)
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeadValidationBlock = _resolveComponent("LeadValidationBlock")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    (_ctx.errorMessages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages, (msg, idx) => {
              return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(msg), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_LeadValidationBlock, {
      ref: "leadValidator",
      "mlm-id": _ctx.mlmId,
      "raw-lead-input": _ctx.rawLeadInput,
      "agent-id": _ctx.agentId,
      onSuccess: _ctx.onValidationSuccess,
      onError: _ctx.onValidationError,
      onValidated: _ctx.onLeadValidated
    }, null, 8, ["mlm-id", "raw-lead-input", "agent-id", "onSuccess", "onError", "onValidated"]), [
      [_vShow, _ctx.showValidationBlock]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.promotionKey) = $event))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotions, (label, key) => {
              return (_openBlock(), _createElementBlock("option", {
                key: key,
                value: key
              }, _toDisplayString(label), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.promotionKey]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amount) = $event)),
            placeholder: "Введите сумму"
          }, null, 512), [
            [
              _vModelText,
              _ctx.amount,
              void 0,
              { number: true }
            ]
          ]),
          _hoisted_11
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rawLeadInput) = $event)),
            placeholder: "Ссылка или номер",
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.invalidateValidation && _ctx.invalidateValidation(...args)))
          }, null, 544), [
            [_vModelText, _ctx.rawLeadInput]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_BaseCheckbox, {
            modelValue: _ctx.holdStatus,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.holdStatus) = $event)),
            label: "Недоступно к выводу сразу"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.isFormLoading }]),
          type: "submit"
        }, "Сохранить", 2)
      ])
    ])
  ], 32))
}